import { render, staticRenderFns } from "./back_default.vue?vue&type=template&id=8fad1376&"
import script from "./back_default.vue?vue&type=script&lang=js&"
export * from "./back_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports